<div class="home-container">
  <h1 class="home-title">Kontakt</h1>

  <div class="home-content">
    Za morebitna vprašanja in dodatne informacije nam pišite na elektronski naslov:<br>
    <a href="mailto:solskilonec@nijz.si">solskilonec@nijz.si</a>
  </div>
</div>
